<template>
    <div>
        <!-- 1階層目メニュー -->
        <v-navigation-drawer v-model="primaryMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in selectedPrimary" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- ポートフォリオメニュー -->
        <v-navigation-drawer v-model="portfolioMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in portfolioMenuItems" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- 成績模試開示設定メニュー -->
        <v-navigation-drawer v-model="seisekiMosiMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in selectedSeisekiMoshi" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- 健康メニュー -->
        <v-navigation-drawer v-model="healthMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in healthMenuItems" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- システム設定メニュー -->
        <v-navigation-drawer v-model="settingMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in selectedSettings" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import MenuItem from './MenuItem.vue'
export default {
    components: {
        MenuItem
    },
    computed: {
        // 1階層目メニュー
        selectedPrimary() {
            return this.primaryMenuItems.filter(
                (item) => {
                    return (item.pattern <= this.$root.menuPattern &&
                        (
                            // ポートフォリオ機能
                            (item.id == 9 && this.$root.portfolioActiveFlg == true) || 
                            // 模試成績開示機能
                            (item.id == 10 && (this.$root.moshiActiveFlg == true || this.$root.testResultActiveFlg == true || this.$root.reportPublishActiveFlg == true)) || 
                            // それ以外
                            (item.id != 9 && item.id != 10)
                        )
                    )
                }
            );
        },
        // 成績模試開示設定メニュー
        selectedSeisekiMoshi() {
            return this.seisekiMosiMenuItems.filter(
                (item) => {
                    return ((item.id == 0) ||
                    (item.id == 1 && this.$root.moshiActiveFlg == true) ||
                    (item.id == 2 && this.$root.testResultActiveFlg == true) ||
                    (item.id == 3 && this.$root.reportPublishActiveFlg == true))
                }
            );
        },
        // システム設定メニュー
        selectedSettings() {
            return this.settingMenuItems.filter(
                (item) => {
                    return (item.pattern <= this.$root.menuPattern)
                }
            );
        },
    },
    data() {
        return {
            // 1階層目メニュー
            primaryMenu: false,
            // ポートフォリオメニュー
            portfolioMenu: false,
            // 成績模試開示設定メニュー
            seisekiMosiMenu: false,
            // 健康メニュー
            healthMenu: false,
            // システム設定メニュー
            settingMenu: false,

            primaryMenuItems: [
                // 教員メニュー
                {
                    id: 0,
                    icon: "mdi-email-plus",
                    name: "連絡の追加",
                    text: "",
                    action: this.toContactRegist,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-email-edit",
                    name: "連絡管理",
                    text: "編集や閲覧状況の確認",
                    action: this.toContactList,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 2,
                    icon: "mdi-table-plus",
                    name: "アンケートの追加",
                    text: "",
                    action: this.toSurveyRegist,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 3,
                    icon: "mdi-table-edit",
                    name: "アンケート管理",
                    text: "編集や記入状況の確認",
                    action: this.toSurveyList,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 4,
                    icon: "mdi-message-cog",
                    name: "個別連絡管理",
                    text: "参加者の変更や連絡の終了",
                    action: this.toTalkRoomList,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 5,
                    icon: "mdi-account-group",
                    name: "グループ管理",
                    text: "登録やメンバーの割当",
                    action: this.toGroupList,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 6,
                    icon: "mdi-account-multiple-check",
                    name: "出欠・早退の追加",
                    text: "＋パスワード初期化",
                    action: this.toGroupSelect,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 7,
                    icon: "mdi-barcode-scan",
                    name: "バーコード受付",
                    text: "学生証スキャンによる出欠状況更新",
                    action: this.toBarcodeCheckIn,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 8,
                    icon: "mdi-database-search-outline",
                    name: "出欠集計確認",
                    text: "出欠集計(HOME)＋遅刻者一覧表出力",
                    action: this.toAttendanceSummary,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 9,
                    icon: "mdi-folder-multiple-outline",
                    name: "ポートフォリオ",
                    text: "課題、活動記録、学習のまとめの管理",
                    action: this.openPortfolioMenu,
                    subMenuFlg: true,
                    pattern: 1,
                },
                {
                    id: 10,
                    icon: "mdi-publish",
                    name: "成績・模試開示設定",
                    text: "学籍システムと連動した成績・通知表・模試の開示設定",
                    action: this.openSeisekiMosiMenu,
                    subMenuFlg: true,
                    pattern: 1,
                },
                {
                    id: 11,
                    icon: "mdi-human-handsup",
                    name: "健康管理(ベータ版)",
                    text: "保健室の入退室など",
                    action: this.openHealthMenu,
                    subMenuFlg: true,
                    pattern: 1,
                },
                {
                    id: 12,
                    icon: "mdi-cog-outline",
                    name: "システム設定",
                    action: this.openSettingMenu,
                    subMenuFlg: true,
                    pattern: 2,
                },
                {
                    id: 13,
                    icon: "mdi-card-account-mail",
                    name: "メールアドレス設定",
                    action: this.toProfileSetting,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 14,
                    icon: "mdi-note-text-outline",
                    name: "利用規約",
                    action: this.toTermsOfService,
                    subMenuFlg: false,
                    pattern: 1,
                },
            ],
            // ポートフォリオメニュー
            portfolioMenuItems: [
                {
                    id: 0,
                    icon: "mdi-chevron-left",
                    name: "戻る",
                    text: "メニューを一つ上の階層に切り替え",
                    action: this.openPrimaryMenu,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-folder-plus",
                    name: "課題登録と提出状況",
                    text: "課題登録と活動記録や学習のまとめの確認",
                    action: this.toPoGroupSelect,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 2,
                    icon: "mdi-folder-eye",
                    name: "課題一覧",
                    text: "所属グループまたぎの課題一覧",
                    action: this.toPoHomeworkListForSelf,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 3,
                    icon: "mdi-update",
                    name: "活動記録タイムライン",
                    text: "活動記録の提出内容やコメントの確認",
                    action: this.toPoActivityRecordTimeline,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 4,
                    icon: "mdi-archive-clock",
                    name: "学習のまとめタイムライン",
                    text: "学習のまとめの提出内容やコメントの確認",
                    action: this.toPoStoryTimeline,
                    subMenuFlg: false,
                    pattern: 1,
                },
            ],
            // 成績模試開示設定
            seisekiMosiMenuItems: [
                {
                    id: 0,
                    icon: "mdi-chevron-left",
                    name: "戻る",
                    text: "メニューを一つ上の階層に切り替え",
                    action: this.openPrimaryMenu,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-publish",
                    name: "模試結果公開設定",
                    text: "学籍システムから連携された模試結果の公開設定",
                    action: this.toPracticeExamSettings,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 2,
                    icon: "mdi-publish",
                    name: "定期試験結果公開設定",
                    text: "学籍システムから連携された定期試験結果の公開設定",
                    action: this.toGradePublishSettings,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 3,
                    icon: "mdi-publish",
                    name: "通知表公開設定",
                    text: "学籍システムから連携された通知表の公開設定",
                    action: this.toReportPublishSettings,
                    subMenuFlg: false,
                    pattern: 1,
                },
            ],
            // 健康メニュー
            healthMenuItems: [
                {
                    id: 0,
                    icon: "mdi-chevron-left",
                    name: "戻る",
                    text: "メニューを一つ上の階層に切り替え",
                    action: this.openPrimaryMenu,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-medical-bag",
                    name: "保健室受付",
                    text: "入退室状況の登録・更新",
                    action: this.toHealthRoomReception,
                    subMenuFlg: false,
                    pattern: 1,
                },
            ],
            // 設定メニュー
            settingMenuItems: [
                {
                    id: 0,
                    icon: "mdi-chevron-left",
                    name: "戻る",
                    text: "メニューを一つ上の階層に切り替え",
                    action: this.openPrimaryMenu,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-wrench-cog-outline",
                    name: "設定変更",
                    text: "出欠ロック日付設定の変更",
                    action: this.toSettingEdit,
                    subMenuFlg: false,
                    pattern: 2,
                },
                {
                    id: 2,
                    icon: "mdi-playlist-plus",
                    name: "出欠登録区分拡張設定",
                    text: "出欠登録に拡張項目を追加・変更",
                    action: this.toAttendanceExpandSetting,
                    subMenuFlg: false,
                    pattern: 2,
                },
                {
                    id: 3,
                    icon: "mdi-cog-transfer",
                    name: "利用機能設定",
                    text: "各種オプション機能の無効化/有効化の変更",
                    action: this.toFeatureSettingEdit,
                    subMenuFlg: false,
                    pattern: 2,
                },
                {
                    id: 4,
                    icon: "mdi-debug-step-over",
                    name: "年度更新",
                    text: "HOMEとしての年度更新",
                    action: this.toAnnualUpdate,
                    subMenuFlg: false,
                    pattern: 2,
                },
            ],
        }
    },
    methods: {
        openDrawer() {
            this.primaryMenu = true;
        },
        // プロフィール設定画面
        toProfileSetting() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "ProfileSetting",
            });
        },
        // 利用規約確認画面
        toTermsOfService() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "TermsOfService",
            });
        },
        // 連絡登録
        toContactRegist() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "ContactRegist",
            });
        },
        // アンケート登録
        toSurveyRegist() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "SurveyRegist",
            });
        },

        // 連絡一覧画面 ⇒ 連絡訂正・未読/既読確認
        toContactList() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "ContactList",
            });
        },
        // アンケート一覧画面 ⇒ アンケート訂正・未読/既読確認
        toSurveyList() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "SurveyList",
            });
        },
        // 個別連絡一覧
        toTalkRoomList() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "TalkRoomList",
            });
        },
        // グループ選択 ⇒ 生徒一覧 ⇒ 出欠訂正 or 早退登録
        toGroupSelect() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "GroupSelect",
            });
        },
        // グループ設定画面
        toGroupList() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "GroupList",
            });
        },
        // バーコード受付画面
        toBarcodeCheckIn() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "BarcodeCheckIn",
            });
        },
        // 出欠集計確認
        toAttendanceSummary() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "AttendanceSummary",
            });
        },

        // ポートフォリオ用メニュー start +++++++++++++++++++++++++++++++++++++++++++
        // 活動記録タイムラインへ
        toPoActivityRecordTimeline() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PoActivityRecordTimeline",
            });
        },
        // 学習のまとめタイムラインへ
        toPoStoryTimeline() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PoStoryTimeline",
            });
        },
        // 課題グループ選択
        toPoGroupSelect() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PoGroupSelect",
            });
        },
        // 課題一覧
        toPoHomeworkListForSelf() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PoHomeworkListForSelf",
            });
        },
        // ポートフォリオ用メニュー end +++++++++++++++++++++++++++++++++++++++++++

        // 成績・模試開示設定用メニュー start +++++++++++++++++++++++++++++++++++++++++++
        // 模試結果公開設定
        toPracticeExamSettings() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PracticeExamSettings",
            });
        },
        // 試験結果公開設定
        toGradePublishSettings() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "GradePublishSettings",
            });
        },
        // 通知表公開設定
        toReportPublishSettings() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "ReportPublishSettings",
            });
        },
        // 成績・模試開示設定用メニュー end +++++++++++++++++++++++++++++++++++++++++++
        
        // 保健室用メニュー start +++++++++++++++++++++++++++++++++++++++++++
        // 保健室受付
        toHealthRoomReception() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "HealthRoomReception",
            });
        },
        // 保健室用メニュー end +++++++++++++++++++++++++++++++++++++++++++

        // システム設定用メニュー start +++++++++++++++++++++++++++++++++++++++++++
        // 設定変更
        toSettingEdit() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "SettingEdit",
            });
        },
        // 出欠登録区分拡張設定
        toAttendanceExpandSetting() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "AttendanceExpandSetting",
            });
        },
        // 利用機能設定
        toFeatureSettingEdit() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "FeatureSettingEdit",
            });
        },
        // 年度更新
        toAnnualUpdate() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "AnnualUpdate",
            });
        },
        // システム設定用メニュー end +++++++++++++++++++++++++++++++++++++++++++

        // メニュー階層制御
        // ポートフォリオメニューを開く
        openPortfolioMenu() {
            this.primaryMenu = false;
            this.portfolioMenu = true;
        },
        // 成績模試開示メニューを開く
        openSeisekiMosiMenu() {
            this.primaryMenu = false;
            this.seisekiMosiMenu = true;
        },
        // 健康メニューを開く
        openHealthMenu() {
            this.primaryMenu = false;
            this.healthMenu = true;
        },
        // 設定メニューを開く
        openSettingMenu() {
            this.primaryMenu = false;
            this.settingMenu = true;
        },
        // 上階層に戻る
        openPrimaryMenu() {
            this.seisekiMosiMenu = false;
            this.portfolioMenu = false;
            this.healthMenu = false;
            this.settingMenu = false;
            this.primaryMenu = true;
        },
    }
}
</script>